
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/where-you-call-home",
      function () {
        return require("private-next-pages/stories/where-you-call-home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/where-you-call-home"])
      });
    }
  